import React from 'react';
import BaseFilter from './base_filter';

import {
    FILTER_OPTIONS,
    SLIDERS_DATA,
    color_values
} from "./filter_constants_and_helpers";

import FilterSelect from '../partners/filter_select'

class ColorFilter extends BaseFilter {

    constructor(props) {
        super(props)

        // get visible options from all options.
        let optionNames = SLIDERS_DATA.color.slice()
        optionNames.push('Fancy')
        this.options = optionNames.map(e => {
            return FILTER_OPTIONS.color.find(s => s.pretty_name === e)
        })

        Object.assign(this.state,this.stored || this._defaultValue())
        this._setDefault = this._setDefault.bind(this)
        this.setFilters = this.setFilters.bind(this)
        this.removeFilter = this.removeFilter.bind(this)
    }

    setFilters(filterName, newValue, removeFunction = this.removeFilter, firstLoad) {
        super.setFilters(filterName,{in:newValue}, removeFunction, firstLoad)
    }

    _apiValues(values) {
        return {in:this._findInterValues(values,'color')}

    }

    removeFilter(name) {
        if ( name ) {
            this.setFilters(ColorFilter.getFilterName(),this._dropDownRemoveFilter(name," " + this._getFilterName()))
        } else {
            this._setDefault()
        }
    }

    /**
     * The following set of function starting with _ are 'protected' and should be called by the base class only.
     * @private
     */
    _defaultValue() {
        return {
            in: []
        }
    }

    _setDefault() {
        this.setFilters(ColorFilter.getFilterName(),this._defaultValue().in)
    }

    _render() {
        return <div>
            <FilterSelect
                label={"Color"}
                name={ColorFilter.getFilterName()}
                options={this.options}
                route={"recent_deals_"+this.props.itemType}
                selectedOptions={this.state.in}
                setFilters={this.setFilters}
                systemName={ColorFilter.getFilterName()}
            />
        </div>
    }

    _getFilterValue() {
        return this.state.in
    }

    _getFilterName() {
        return ColorFilter.getFilterName()
    }

    _tagName(newState) {
        let tagList = []
        for ( let id of newState.in ) {
            let option = this.options.find(e => e.id == id)
            if ( option ) tagList.push(option.pretty_name + " " + this._getFilterName())
        }
        return tagList
    }

    _apiKeys() {
        return ["in"]
    }

    /**
     * static functions to be supported without an instance for generic filter usage implementations.
     * @returns {string}
     */
    static getFilterName() {
        return "color"
    }
}

export default ColorFilter;